<section class="sect-char" id="caracteristicas" appViewportEnterDirective (viewPortEntered)="activeRoute.setActiveRoute('home-chara')">
    <h2>
        <span>Características</span><br />
            que impulsan <span>x10</span> tu gestión
        
    </h2>

    <div class="grid">
        <div class="grid-child grid-child1">
            <div class="icon">

                <span class="pi pi-clock"></span>
            </div>
            <p class="child-title">Responde las 24 horas, <span>los 365 días del año</span> </p>
            <p> <span>AdminAI responde y resuelve.</span> Se integra a tu WhatsApp y contesta sólo a tus consorcistas a partir de la información que le suministres una única vez, sin importar día u hora.  </p>
            <img class="texture" src="./assets/grid-img2.png" alt="textura de fondo">
        </div>
        <div class="grid-child grid-child2">
            <div class="icon">
                <span class="pi pi-wrench"></span>
            </div>
            <p class="child-title">Coordina y sigue trabajos</p>
            <p>AdminAI crea grupos entre los involucrados y el prestador. Se asegura de que el trabajo quede terminado. Al mismo tiempo genera un registro de tu gestión.</p>
        </div>
        <div class="grid-child grid-child3">
              <div class="icon">

                <span class="pi pi-building"></span>
            </div>
            <img class="texture" src="./assets/grid-img5.png" alt="textura de fondo">
            <p class="child-title"> <span>Se adapta</span> a cada consorcio</p>
            <p>Configurá la información de cada consorcio por única vez y <span>AdminAI se ocupa del resto: </span> preguntas frecuentes, amenities, servicios, números de urgencia. ¡Incluso podés cargar el reglamento!</p>
        </div>
        <div class="grid-child grid-child4">
              <div class="icon">

                <span class="pi pi-address-book"></span>
            </div>
            <p class="child-title">Mantiene datos actualizados</p>
            <p>Con AdminAI la información de tus consorcistas está <span> siempre al día.</span> Si alguien se muda, serás notificado para admitirlo y actualizar tus registros. </p>
            <img src="./assets/grid-img8.png" alt="" class="texture">
        </div>
        <div class="grid-child grid-child5">
              <div class="icon">
                <span class="pi pi-bell"></span>
            </div>
            <div class="text-cont">
                <p class="child-title">Resuelve <span>urgencias</span></p>
                <p> <span>AdminAI interpreta cuando algo es un riesgo </span>y deriva con el prestador que hayas indicado para casos urgentes. También te avisa de la situación al teléfono que indiques y sigue la situación hasta que esté resuelta.</p>
            </div>
        </div>
    </div>
</section>